export default {
	gameToken: null,
	fayeChannel: null,
	startGameHandler: null,
	userPingTimeout: 5000,
	onlineStatusPingInterval: 2000,
	lobbyStatusObserveInterval: 15000,
	userData: {},
	excludedGenericUserIds: [],
	ownUserData: {},
	attachedChangeHandleInitializers: [],

	init(gameToken, ownUserData, userDataString) {
		pp.log(
			"GAME TOKEN LOBBY init -- token, ownUserData, User data",
			gameToken,
			ownUserData,
			userDataString,
		);
		this.gameToken = gameToken;
		this.ownUserData = ownUserData;
		this.setUserData(userDataString);
		// @ts-expect-error
		this.fayeChannel = `/game_tokens/${gameToken}/lobby`;

		// @ts-expect-error
		this.attachedChangeHandleInitializers.push(this.addListenerForUser);

		this.initPrivatePubPingAndSubscriptions();

		if (!this.ownUserData.isModerator) {
			// Don't use for moderators
			this.initLobbyStatusObserver();
		}

		// Check if the User name is set and if so, report being online once subscribed.
		// In Unionslabor Games the User name will have to be filled out in step 1 of the waiting room, so it might be nil
		if (this.ownUserData.name && !this.ownUserData.isModerator) {
			$(document).on("senaryon:subscribedFayeChannel", function () {
				pp.gameTokenLobby.reportOnlineWithStatus("newlyOnline");
			});
		}

		$(document).one("page:before-change", () => {
			this.userData = {}; // Wipe the data
			this.removeAttachedChangeHandleInitializer(this.addListenerForUser);
		});
	},

	setUserData(userDataString) {
		this.userData = JSON.parse(userDataString, this.revivingFunction);
		// pp.log("setting", this.userData);

		// Trigger once now, but wait a bit so that other listeners (i.e. in the Unionslabor waiting room) have also been registered
		setTimeout(() => {
			Object.keys(this.userData).forEach((userId) => {
				// @ts-expect-error
				if (isNaN(userId)) {
					return; // Don't observe the 'observeChangeHandlers' key
				}
				for (let i in this.attachedChangeHandleInitializers) {
					// @ts-expect-error
					this.attachedChangeHandleInitializers[i](userId, true);
				}
			});
		}, 10);
	},

	// `fromInitfunction` is unused here
	addListenerForUser(userId, fromInitfunction = false) {
		pp.gameTokenLobby.userData.observeChange(userId, function (oldval, newval) {
			pp.gameTokenLobby.handleLobbyUserDataChange(userId, oldval, newval);
		});
		setTimeout(() => {
			// slightly hacky: let `handleLobbyUserDataChange` in the waiting room fire first to set all the data attributes on DOM elements
			// so that they can then be filled from this `handleLobbyUserDataChange`
			pp.gameTokenLobby.handleLobbyUserDataChange(
				userId,
				null,
				pp.gameTokenLobby.userData[userId],
			);
		});
	},

	handleLobbyUserDataChange(userId, oldval, newval) {
		// pp.log("handleLobbyUserDataChange", userId, oldval, newval);
		if (
			(!oldval || !oldval.lastSeen) &&
			!this.ownUserData.isModerator &&
			userId != this.ownUserData.id
		) {
			// must have come newly online
			// Broadcast own User id so that the new User gets it
			this.reportOnlineWithStatus("alreadyOnline");
		}

		if (newval) {
			if (newval.lastSeen && newval.name) {
				$(`[data-lobby-status-for-user-id=${userId}]`).addClass("online");
			}
			if (newval.name) {
				$(`[data-lobby-name-for-user-id=${userId}]`).text(newval.name);
			}
			if (newval.quizCompletedWithLane) {
				$(`[data-lobby-quiz-lane-for-user-id=${userId}]`).text(
					newval.quizCompletedWithLane,
				);
				$(`[data-lobby-quiz-status-for-user-id=${userId}]`).html("Bereit");
			}
		}
		if (!newval || !newval.lastSeen) {
			$(`[data-lobby-status-for-user-id=${userId}]`).removeClass("online");
		}
	},

	usersWithPropertyCount(keyName, operator, comparisonValue) {
		const userIds = Object.keys(this.userData).filter((userId) => {
			// @ts-expect-error
			if (isNaN(userId)) {
				// userId might actually be the `observeChangeHandlers` hash
				return false;
			}
			const valueOfKey = this.userData[userId][keyName];
			if (typeof valueOfKey === "string") {
				return eval(`'${valueOfKey}' ${operator} ${comparisonValue}`);
			} else {
				return eval(`${valueOfKey} ${operator} ${comparisonValue}`);
			}
		});
		return userIds.length;
	},

	initPrivatePubPingAndSubscriptions() {
		// @ts-expect-error
		PrivatePub.subscribe(this.fayeChannel, function (data, channel) {
			// pp.log("incoming", data);
			if (data !== undefined) {
				pp.gameTokenLobby.handleIncomingData(data);
			}
		});

		if (!this.waitingInterval) {
			this.waitingInterval = window.setInterval(() => {
				pp.gameTokenLobby.keepWaitingUsersCurrent();
				if (!pp.gameTokenLobby.ownUserData.isModerator) {
					pp.gameTokenLobby.reportOnlineWithStatus("alreadyOnline"); // broadcast own User data, but not for mods
				}
			}, this.onlineStatusPingInterval);
		}
		$(document).one("page:before-change", () => {
			// @ts-expect-error
			PrivatePub.deleteNonFeed(pp.gameTokenLobby.fayeChannel, "page changed");
			clearInterval(pp.gameTokenLobby.waitingInterval);
			pp.gameTokenLobby.waitingInterval = null;
		});
	},

	sendViaPrivatePub(data) {
		// pp.log("Attempting to send Lobby PrivatePub", data);
		// @ts-expect-error
		if (PrivatePub.fayeClient == null) {
			return;
		}
		// @ts-expect-error
		PrivatePub.fayeClient
			.publish(this.fayeChannel, { data: data }, { attempts: 3 })
			.then(
				function () {
					// pp.log("LOBBY message received by Faye server!");
				},
				function (error) {
					pp.log(
						"LOBBY Faye error while sending message -- error:",
						error.message,
					);
				},
			);
	},

	updateLobbyUserEntry(userId, key, value) {
		const isNewEntry = this.userData[userId] === undefined;
		let newObj = Object.assign({}, this.userData[userId]);
		newObj[key] = value;

		// pp.log("gameTokenLobby updateLobbyUserEntry", newObj, isNewEntry);
		this.userData[userId] = newObj;
		if (isNewEntry) {
			setTimeout(() => {
				// Wait a bit so that more than one data entry can be set
				for (let i in this.attachedChangeHandleInitializers) {
					// @ts-expect-error
					this.attachedChangeHandleInitializers[i](userId);
				}
			}, 10);
		}
	},

	// When you want to update multiple properties on the user, and trigger only one change event.
	updateLobbyUserEntryMultipleProps(userId, newProps) {
		const isNewEntry = this.userData[userId] === undefined;
		const newObj = Object.assign({}, this.userData[userId], newProps);

		this.userData[userId] = newObj;
		// pp.log("gameTokenLobby updateLobbyUserEntryMultipleProps", newObj, isNewEntry);
		if (isNewEntry) {
			setTimeout(() => {
				// wait a bit so that more than one data entry can be set
				for (let i in this.attachedChangeHandleInitializers) {
					// @ts-expect-error
					this.attachedChangeHandleInitializers[i](userId);
				}
			}, 10);
		}
	},

	handleIncomingData(data) {
		// pp.log("into handleIncomingData", data, this.userData[data.id]);
		if (data.newlyOnline == true || data.alreadyOnline == true) {
			if (this.userData[data.id] && this.userData[data.id].actorId == -1) {
				return;
			}
			this.updateLobbyUserEntry(data.id, "lastSeen", new Date().getTime());
			this.updateLobbyUserEntry(data.id, "name", data.name);
			if (data.actorId) {
				this.updateLobbyUserEntry(data.id, "actorId", data.actorId);
			} else if (!this.userData[data.id].actorId) {
				// Cannot be `undefined`
				this.updateLobbyUserEntry(data.id, "actorId", null);
			}
			if (data.email) {
				this.updateLobbyUserEntry(data.id, "email", data.email);
			}
		} else if (data.newlyOfflineUserId) {
			this.updateLobbyUserEntry(data.newlyOfflineUserId, "lastSeen", null);
		} else if (data.quizCompletedById) {
			this.updateLobbyUserEntry(
				data.quizCompletedById,
				"quizCompletedWithLane",
				data.laneTitle,
			);
		} else if (data.start_game == true && this.startGameHandler) {
			// @ts-expect-error
			this.startGameHandler();
		} else if (
			data.kickUser === true &&
			this.ownUserData.email === data.userEmail
		) {
			window.location.replace("/users/logout?reason=isExcludedFromUserManager");
		}
	},

	keepWaitingUsersCurrent() {
		Object.keys(this.userData).forEach((userId) => {
			const userData = this.userData[userId];
			// never seen or last seen longer than ping timeout
			if (
				userData.lastSeen &&
				new Date().getTime() - userData.lastSeen > this.userPingTimeout
			) {
				this.updateLobbyUserEntry(userId, "lastSeen", null);
			}
		});
	},

	reportOnlineWithStatus(status) {
		let dataToSend = Object.assign({}, this.ownUserData);
		dataToSend[status] = true;
		pp.gameTokenLobby.sendViaPrivatePub(dataToSend);
	},

	initLobbyStatusObserver() {
		const tokenStatusCallback = (result) => {
			// Refresh the page if the Game has started and this information didn't make it to the user via Faye
			if (result.status_code == "token_redeemed") {
				// @ts-expect-error
				this.startGameHandler();
			} else if (result.status_code == "forbidden") {
				window.location.replace("/");
			}
		};

		this.lobbyStatusObserver = setInterval(() => {
			pp.tokens.getTokenStatus(this.gameToken, tokenStatusCallback);
		}, this.lobbyStatusObserveInterval);
		$(document).one("page:before-change", () => {
			clearInterval(pp.gameTokenLobby.lobbyStatusObserver);
		});
	},

	revivingFunction(key, val) {
		if (val === true || val === "true") {
			return true;
		}
		if (val === false || val === "false") {
			return false;
		}
		if (val && !isNaN(val)) {
			// Is not null, not undefined, and not not a number
			return parseInt(val, 10);
		}
		return val; // Else
	},

	removeAttachedChangeHandleInitializer(listener) {
		const indexOfListener =
			// @ts-expect-error
			pp.gameTokenLobby.attachedChangeHandleInitializers.indexOf(listener);
		if (indexOfListener != -1) {
			// pp.log("removing listener from pp.gameTokenLobby.attachedChangeHandleInitializers -- listener", listener);
			pp.gameTokenLobby.attachedChangeHandleInitializers.splice(
				indexOfListener,
				1,
			);
		}
	},
};
